function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import autoBind from 'auto-bind';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EVENT_PLAYER_PROGRESSED } from './index';

var BTBaseVideoPlayer = /*#__PURE__*/function () {
  function BTBaseVideoPlayer(_ref) {
    var name = _ref.name;

    _classCallCheck(this, BTBaseVideoPlayer);

    this._name = name;
    this._initialized = false;
    this._eventBus = new ReplaySubject();
    this._playerProgressBus = new BehaviorSubject({
      seconds: 0
    });
    autoBind(this);
  }
  /**
   * The Player Name
   * @returns {string}
   */


  _createClass(BTBaseVideoPlayer, [{
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "playerType",
    get: function get() {
      return 'BASE';
    }
    /**
     * Subscribe to player events.
     * @param {string} event - The name of the event
     * @param {function} listener - The function to be called when the event is triggered.
     */

  }, {
    key: "subscribe",
    value: function subscribe(event, listener) {
      if (event === EVENT_PLAYER_PROGRESSED) {
        return this._playerProgressBus.subscribe(listener);
      } else {
        return this._eventBus.pipe(filter(function (evt) {
          return evt.event === event;
        })).subscribe(listener);
      }
    }
  }, {
    key: "play",
    value: function play() {
      console.error('Cannot call play on Base Player');
      return Promise.resolve(null);
    }
  }, {
    key: "pause",
    value: function pause() {
      console.error('Cannot call pause on Base Player');
      return Promise.resolve(null);
    }
  }, {
    key: "mute",
    value: function mute() {
      console.error('Cannot call mute on Base Player');
      return Promise.resolve(null);
    }
  }, {
    key: "unmute",
    value: function unmute() {
      console.error('Cannot call unmute on Base Player');
      return Promise.resolve(null);
    }
  }, {
    key: "_log",
    value: function _log(msg) {
      console.debug("[".concat(this.playerType, "] ").concat(msg));
    }
  }]);

  return BTBaseVideoPlayer;
}();

export { BTBaseVideoPlayer as default };